import "./App.css";
import {
  CircularProgress,
  Accordion,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import React, { useEffect, useState } from "react";
import axios from "axios";
import GameItem from "./components/GameItem";

class League {
  constructor(leagueId, marketId) {
    this.leagueId = leagueId;
    this.marketId = marketId;
  }
}

export function converDecimalToAmerican(decimal, toConvert) {
  if (!toConvert) return decimal;
  if (decimal >= 2) return "+" + Math.ceil((decimal - 1) * 100);
  return Math.ceil(-100 / (decimal - 1));
}

function getCountry() {
  let hostname = window.location.hostname;
  let splittedHostname = hostname.split(".");
  let extension = splittedHostname[splittedHostname.length - 1];

  switch (extension) {
    case "es":
      return "spain";
    case "pa":
      return "panama";
    case "co":
      return "colombia";
    case "ar":
      return "argentina";
    default:
      return "colombia";
  }
}

function importImages(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

function App() {
  const country = getCountry();

  const urlParams = window.location.search.substring(1);
  const leagueRegex = /(?:leagueId=(\d+)\+marketId=(\d+))/g;
  const [expanded, setExpanded] = useState("panel1");
  const handleChange = (panel) => (isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const importedIcons = importImages(
    require.context("./assets", false, /\.(png)$/)
  );

  const headerBanner =
    "https://coderetech.com/blog-widget-assets/change-country.jpg";

  const iconHandler = (sportName) => {
    const cases = [
      { keyword: "Fútbol", icon: "football" },
      { keyword: "MMA", icon: "ufc" },
      { keyword: "Baloncesto", icon: "basketball" },
      { keyword: "Tenis", icon: "tennis" },
      { keyword: "NFL", icon: "nfl" },
      { keyword: "Béisbol", icon: "baseball" },
      { keyword: "eSports", icon: "e-sport" },
    ];

    for (const { keyword, icon } of cases) {
      if (sportName.includes(keyword)) {
        return icon;
      }
    }

    return cases[0].icon;
  };

  // const leagueList = [
  //   { leagueId: "2903511051", marketId: "1" }, // futbol - Primera División - 1x2
  //   { leagueId: "2817453712", marketId: "1" }, // futbol - UEFA, Champions League - 1x2
  //   { leagueId: "2817453708", marketId: "1" }, // futbol - Premier League - 1x2
  //   { leagueId: "3069005120", marketId: "1" }, // futbol - Primera A Colombia - 1x2
  //   { leagueId: "3361963058", marketId: "1" }, // futbol - Copa Libertadores - 1x2

  //   { leagueId: "3381766890", marketId: "97" }, // basketball - nba - ganador
  //   { leagueId: "3381766890", marketId: "159" }, // basketball - nba - handicap

  //   { leagueId: "3697988354", marketId: "97" }, // tennis - ATP Monte-Carlo - ganador

  //   { leagueId: "2819844675", marketId: "97" }, // mma - ufc - ganador

  //   { leagueId: "2819833171", marketId: "97" }, // beisbol - MLB - ganador

  // ];

  const [leagueList, setLeaugeList] = useState([]);
  const [games, setGames] = useState([]);
  const [odds, setOdds] = useState([]);

  useEffect(() => {
    // console.log(">>>");
    // console.log(leagueList);
  }, [leagueList]);
  useEffect(() => {
    // if (!urlParams) setLeaugeList([new League("2903511051", "1")]);
    if (!urlParams)
      setLeaugeList([
        new League(
          serversObject[country].defaultLeagueId,
          serversObject[country].defaultMarketId
        ),
      ]);
    else {
      const pairs = [];
      let match;
      while ((match = leagueRegex.exec(urlParams)) !== null) {
        const leagueId = match[1];
        const marketId = match[2];
        pairs.push({ leagueId, marketId });
      }

      setLeaugeList([...pairs]);
    }
  }, []);
  /* 
  https://m.apuestas.codere.es/deportesEs/#/MercadosPage
  https://m.codere.com.co/deportesCol/#/MercadosPage
  https://m.codere.pa/deportespanama/#/MercadosPage
  https://m.caba.codere.bet.ar/Deportes/#/MercadosPage
  */

  const serversObject = {
    spain: {
      betSlipPrefixURL: "https://m.apuestas.codere.es/deportesEs/#/HomePage",
      defaultLeagueId: "2903511051",
      defaultMarketId: "1",
      url: "https://m.apuestas.codere.es/deportesEs/#/MercadosPage",
      wbUrl:
        "https://m.apuestas.codere.es/deportesEs/#/mso/PromotionsPage?animate=false&url=https:%2F%2Fwww.codere.es%2FPromosCalidad%2Factives%2FWB_sport_optin.html",
    },
    panama: {
      betSlipPrefixURL: "https://m.codere.pa/deportespanama/#/HomePage",
      defaultLeagueId: "2817453710",
      defaultMarketId: "1",
      url: "https://m.codere.pa/deportespanama/#/MercadosPage",
      wbUrl:
        "https://m.codere.pa/deportespanama/#/mso/PromotionsPage?url=https://www.codere.pa/PromocionesPA/actives/PA_2011_ALL_WBPanama_CAS.aspx",
    }, // Serie A - 1
    colombia: {
      betSlipPrefixURL: "https://m.codere.com.co/deportesCol/#/HomePage",
      defaultLeagueId: "2817453710",
      defaultMarketId: "1",
      url: "https://m.codere.com.co/deportesCol/#/MercadosPage",
      wbUrl:
        "https://www.codere.com.co/PromosCO/actives/CO0107ALLWBColombia2SP.aspx",
    }, // Serie A - 1
    argentina: {
      betSlipPrefixURL: "https://m.caba.codere.bet.ar/Deportes/#/HomePage",
      defaultLeagueId: "3361963058",
      defaultMarketId: "1",
      url: "https://m.caba.codere.bet.ar/Deportes/#/MercadosPage",
      wbUrl:
        "https://www.codere.bet.ar/PromosCalidad/actives/WB-AR-SPORT-200.aspx",
    }, // Copa Libertadores - 1
    mexico: {
      betSlipPrefixURL: "https://apuestas.codere.mx/add-selns?lang=es_MX",
      defaultLeagueId: "2957367777",
      defaultMarketId: "1",
      url: "https://apuestas.codere.mx/es_MX",
      wbUrl: "https://www.codere.mx/promociones/welcome-bonus-hasta-5000-fd",
    }, // Liga MX - 1
  };

  const URL = process.env.REACT_APP_SERVER;

  const headers = {
    CodereAffiliateApiKey: process.env.REACT_APP_KEY,
    CodereAffiliateApiSecret: process.env.REACT_APP_SECRET,
  };

  useEffect(() => {
    const fetchGames = async () => {
      const promises = leagueList.map((league) => {
        const url = URL.replace(
          "_changecountryprefix",
          country === "spain" ? "" : country.substring(0, 2)
        )
          .replace("changeleagueid", league.leagueId)
          .replace("changemarketid", league.marketId);
        // console.log(url);
        return axios.get(url, { headers });
      });

      try {
        const responses = await Promise.all(promises);

        // console.log(responses);

        const updatedGames = responses
        .flatMap((res) => [
          res.data
            .map((game) => ({
              ...game,
              StartDate: new Date(parseInt(game.StartDate.match(/\d+/)[0]))
                .toISOString()
                .replace(/\.\d{3}Z$/, 'Z'),
            }))
            .sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate)),
        ])
        .filter((item) => item.length);

        // console.log("filtered >>");
        // console.log(updatedGames);

        updatedGames.forEach((updatedGame, i) => {
          let tempOdds = updatedGames.flatMap((updatedGame) => [
            updatedGame.flatMap((game) => [
              game.Games[0].Results.map((odd) => odd.Odd),
            ]),
          ]);

          setOdds([...tempOdds]);
        });

        if (updatedGames.length) setGames([...updatedGames]);

        // setLeaugeList([new League("2903511051", "1")]);
      } catch (error) {
        console.log(error);
        console.log("error avner");
        setLeaugeList([
          new League(
            serversObject[country].defaultLeagueId,
            serversObject[country].defaultMarketId
          ),
        ]);
      }
    };

    fetchGames();
    return () => {
      // setLeaugeList([new League("2903511051", "1")]);
    };
  }, [leagueList]);

  return (
    <div className="App">
      <div className="widget-wrapper">
        <a href={serversObject[country].url} target="_blank">
          <img
            className="banner"
            width="430"
            height="430"
            src={`${headerBanner.replace("change-country", country)}`}
          />
        </a>
        <a className="tyc" target="_blank" href={serversObject[country].wbUrl}>
          <span>Términos y Condiciones</span>
        </a>

        {!games.length ? (
          <CircularProgress
            style={{ color: "#fff", margin: "1rem auto", display: "flex" }}
          />
        ) : (
          <>
            {games.map((branch, i) => (
              <Accordion
                key={i}
                className="acc"
                expanded={expanded === `panel${i + 1}`}
                onChange={handleChange(
                  expanded === `panel${i + 1}` ? "false" : `panel${i + 1}`
                )}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  aria-controls={`panel${i + 1}bh-content`}
                  id={`panel${i + 1}bh-header`}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      flexShrink: 0,
                      fontWeight: 700,
                    }}
                  >
                    <img
                      style={{ marginRight: "15px" }}
                      width={20}
                      height={20}
                      src={
                        importedIcons[`${iconHandler(branch[0].SportName)}.png`]
                      }
                    />
                    {/* {console.log(branch[0])} */}
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span>
                        {branch[0].SportName} - {branch[0].LeagueName}
                      </span>
                      <span style={{ fontSize: "0.75rem" }}>
                        {branch[0].Games[0].Name}
                      </span>
                    </span>
                  </Typography>
                </AccordionSummary>
                <GameItem
                  branch={branch}
                  odds={odds}
                  i={i}
                  urlPrfix={serversObject[country].url}
                  country={country}
                  betSlipPrefix={serversObject[country].betSlipPrefixURL}
                />
              </Accordion>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default App;
